import React, { useContext, useEffect } from "react";
import { ReactComponent as Error404 } from "../../img/404.svg";
import { StyledErrorContainer, StyledErrorTitle, StyledErrorP } from "./404.style.js";
import StateContext from "../../context/StateContext";
import LinkButton from "components/utils/linkButton/LinkButton.component";
import Sentry from "services/sentry";


const Page404 = () => {
	const { dispatch, ACTIONS } = useContext(StateContext);

	useEffect(() => {
		let didCancel = false;
		if (!didCancel) {
			dispatch({ type: ACTIONS.SET_SPINNER, payload: false });
		}
		return () => (didCancel = true);
	}, );

	return (
		<StyledErrorContainer>
			<StyledErrorTitle>The page requested doesn't exist</StyledErrorTitle>
			<StyledErrorP>
				If you’re still stuck, shoot us an email at{" "}
				<a rel="noreferrer" target="_blank" href="mailto:support@fixel.ai">
					support@fixel.ai
				</a>
			</StyledErrorP>
			<StyledErrorP>
				or report to us directly&nbsp;
				<LinkButton 
					onClick={
							()=>{Sentry.showReportDialog({eventId:Sentry.captureMessage("404 page invocation")});}
						} >
						Here
				</LinkButton>
			</StyledErrorP>
			<Error404 />
		</StyledErrorContainer>
	);
};
export default Page404;
